import React from 'react';

const CurrentWidget = ({ speed = "1.2", unit = "KTS" }) => {
  return (
    <div className="instrument-widget" style={{ position: 'relative' }}>
      <span style={{ position: 'absolute', top: '8px', left: '8px', fontSize: '14px' }}>🇵🇭</span>
      <div className="current-display">
        <span className="current-num">{speed}</span>
      </div>
      <div className="counter-label">CURRENT</div>
      <div className="status-tag current-status">{unit}</div>
    </div>
  );
};

export default CurrentWidget;
